import { Button, Tabs } from "antd";
import './draggableTab.css';
import { DndContext, PointerSensor, useSensor } from '@dnd-kit/core';
import {
  arrayMove,
  horizontalListSortingStrategy,
  SortableContext,
  useSortable,
} from '@dnd-kit/sortable';
import dragimg from '@src/assets/img/draggable.svg';
import React from "react";


export const DraggableTabNode = ({ className, ...props }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: props['data-node-key'],
    });
    const style = {
      ...props.style,
      transform: CSS?.Transform?.toString(
        transform && {
          ...transform,
          scaleX: 1,
        },
      ),
      transition,
      cursor: 'pointer',
    };
    return React.cloneElement(props.children, {
      ref: setNodeRef,
      style,
      ...attributes,
      ...listeners,
    });
  };

export const SimpleTab = ({tabname})=>{

    const sensor = useSensor(PointerSensor, {
        activationConstraint: {
        distance: 100,
        },
    });
    const onDragEnd = ()=>{}


    return (
        <div style={{padding:' 6px 48px 0px'}}>
            <div
                className='setting-body-inner grid-tabs simpleTab' style={{
                    padding: '25px 48px 0px', 
                    display: 'flex', alignItems:'center', borderBottom:'1px solid rgb(203, 214, 226)',
                    height: '31px',
                    marginTop:'10px',
                }}
            >
                <Tabs       
                    closeIcon={true}
                    renderTabBar={(tabBarProps, DefaultTabBar) => (
                        <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
                        <SortableContext items={[{key: tabname}]} strategy={horizontalListSortingStrategy}>
                            <DefaultTabBar {...tabBarProps}>
                            {(node) => (
                                <DraggableTabNode {...node.props} key={node.key}>
                                    {node}
                                </DraggableTabNode>
                            )}
                            </DefaultTabBar>
                        </SortableContext>
                        </DndContext>
                    )}
                >

                    <Tabs.TabPane  tab={
                        <div className='dragContent'>
                
                            <img src={dragimg} alt="" className='dragimg'/> 
                            <div style={{width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center'}}> {tabname} </div> 
                            
                        </div>
                        } 
                    />


                </Tabs>
            </div>
        </div>

    )
}